import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ApprovalActionErrorCode as ERR_CODE, ApprovalActionState as STATE, PaymentMethodDetailType } from 'app/model/constant';

import { AppConfigService } from 'app/services/app-config/app-config.service';
import { ApprovalService } from 'app/services/approval/approval.service';
import { Router } from '@angular/router';
import { Subscription, Observable } from 'rxjs/Rx';
import { BookerCancellationCharge, BookingCancellationStatus } from '../../../model/booking/booking-cancellation';
import { Language as LANG } from '../../../model/constant';
import * as moment from 'vendors/moment-locale-th';
import { ErrorDto } from '../../../services/stub';

class DisplayPayment {
  label: string;
  amount: number;
}
@Component({
  selector: 'act-approval-action',
  templateUrl: './approval-action.component.html',
  styleUrls: ['./approval-action.component.scss']
})
export class ApprovalActionComponent implements OnInit, OnDestroy {
  @Input('bookingId') bookingId: any;
  @Input('approvalRef') approvalRef: any;
  @Input('approvalAction') approvalAction: any;

  private subscriptionGetBookingCancellationStatus: Subscription;
  private subscriptionUpdateBookingApprovalStatus: Subscription;

  public bookingCancellationStatus: BookingCancellationStatus;
  public cancellationChargeList: any;
  public cancellationFee: number;
  public currentLang: string;

  public paymentCreditTerms = null;
  public paymentCoBooker = null;
  public displayPaymentNonCreditTermList: DisplayPayment[] = [];
  public PaymentMethodDetailType = PaymentMethodDetailType

  public isShareBudget = false;
  public isMultiPayment = false;

  private STATE = STATE;
  private LANG = LANG;

  private state = {
    [STATE.APPROVED]: false,
    [STATE.REJECT_WITH_FEE]: false,
    [STATE.REJECT_FREE]: false,
    [STATE.REJECTED]: false,
    [STATE.UNABLE_APPROVAL]: false
  };

  private loading = {
    PAGE: false,
    BUTTON: false
  };

  reasonText: string;
  isReasonError: boolean;

  constructor(
    public router: Router,
    private appConfigService: AppConfigService,
    private approvalService: ApprovalService,
  ) { }

  ngOnInit() {
    this.setLoading('PAGE');
    this.currentLang = this.appConfigService.getLanguage();

    if (this.approvalAction === 'reject') {
      this.getBookingCancellationStatus();
    } else {
      this.updateBookingApprovalStatus();
    }
  }

  getBookingCancellationStatus() {
    this.subscriptionGetBookingCancellationStatus = this.approvalService.getBookingCancellationStatus(this.bookingId, this.approvalRef)
      .subscribe((data: BookingCancellationStatus) => {
        if (data) {
          this.bookingCancellationStatus = data;
          if (data.cancellationChargeList) {
            this.cancellationChargeList = data.cancellationChargeList;
            this.cancellationChargeList = this.cancellationChargeList.map((item: any) => {
              return {
                ...item,
                cancellationDate: item.fromDate ? moment(item.fromDate).locale(this.currentLang).format('DD MMM YY') : undefined,
              };
            });
            this.cancellationFee = data.totalCharge;

            if (data.bookerCancellationChargeList !== undefined) {
              const bookerCancellationChargeList: BookerCancellationCharge[] = data.bookerCancellationChargeList;
              if (bookerCancellationChargeList.filter(cancellation => cancellation.paymentType === PaymentMethodDetailType.CREDIT_TERMS).length > 1) {
                this.isShareBudget = true;
              }
              for (let i = 0; i < bookerCancellationChargeList.length; i++) {
                if (bookerCancellationChargeList[i].paymentType === PaymentMethodDetailType.CREDIT_TERMS) {
                  if (this.isShareBudget) {
                    if (bookerCancellationChargeList[i].mainBooker) {
                      this.paymentCreditTerms += bookerCancellationChargeList[i].totalCharge;
                    } else {
                      this.paymentCoBooker += bookerCancellationChargeList[i].totalCharge;
                    }
                  } else {
                    this.paymentCreditTerms += bookerCancellationChargeList[i].totalCharge;
                  }
                }
                if (bookerCancellationChargeList[i].paymentType !== PaymentMethodDetailType.CREDIT_TERMS) {
                  let label = '';
                  switch (bookerCancellationChargeList[i].paymentType) {
                    case PaymentMethodDetailType.CREDIT_CARD:
                      label = 'booking-cancellation-credit-card'
                      break;
                    case PaymentMethodDetailType.TRUE_MONEY:
                      label = 'booking-cancellation-true-money'
                      break;
                    case PaymentMethodDetailType.CORPORATE_FLEET:
                      label = 'booking-cancellation-corporate-fleet'
                      break;
                    case PaymentMethodDetailType.PERSONAL_FLEET:
                      label = 'booking-cancellation-personal-fleet'
                      break;
                  }
                  this.displayPaymentNonCreditTermList.push({
                    label,
                    amount: bookerCancellationChargeList[i].totalCharge
                  })
                }
              }
              this.isMultiPayment = bookerCancellationChargeList.length > 1;
            }

            if (this.cancellationFee > 0) {
              this.setState(STATE.REJECT_WITH_FEE);
            } else {
              this.setState(STATE.REJECT_FREE);
            }
          }
        } else {
          this.setState(STATE.UNABLE_APPROVAL);
        }
      },
        (errors) => {
          this.setState(STATE.UNABLE_APPROVAL);
        });
  };

  updateBookingApprovalStatus(action: string = 'approve') {
    let updateBookingApprovalStatus: Observable<any>;
    switch (action) {
      case 'approve':
        updateBookingApprovalStatus = this.approvalService.approveBooking(this.bookingId, this.approvalRef, false);
        break;
      case 'reject':
        if (this.isReasonError === false) {
          this.setLoading('BUTTON'); 
          updateBookingApprovalStatus = this.approvalService.rejectBooking(this.bookingId, this.approvalRef, this.reasonText, false);
        } else {
          this.isReasonError = true;
        }
    }
    this.subscriptionUpdateBookingApprovalStatus = updateBookingApprovalStatus.subscribe(
      (response) => this.handleResponse(),
      (errors) => this.setState(STATE.UNABLE_APPROVAL));
  }

  handleResponse() {
    if (this.approvalAction === 'approve') {
      this.setState(STATE.APPROVED);
    } else if (this.approvalAction === 'reject') {
      this.setState(STATE.REJECTED);
    } else {
      this.setState(STATE.UNABLE_APPROVAL);
    }
  }

  setState(value: string = '') {
    this.setLoading();
    for (const name in this.state) {
      if (this.state.hasOwnProperty(name)) {
        this.state[name] = (name === value);
      }
    }
  }

  setLoading(value: string = '') {
    for (const name in this.loading) {
      if (this.loading.hasOwnProperty(name)) {
        this.loading[name] = (name === value);
      }
    }
  }

  goToHome() {
    this.router.navigateByUrl('?lang=' + this.appConfigService.getLanguage());
  }

  goToApprovalList() {
    this.router.navigateByUrl('/approval?lang=' + this.appConfigService.getLanguage() + '&bookingid=' + this.bookingId);
  }

  ngOnDestroy() {
    this.subscriptionGetBookingCancellationStatus && this.subscriptionGetBookingCancellationStatus.unsubscribe();
    this.subscriptionUpdateBookingApprovalStatus && this.subscriptionUpdateBookingApprovalStatus.unsubscribe();
  }

  onKeyupReason(text: string) {
    this.isReasonError = text && text.trim().length > 0 ? false : true;
    this.reasonText = text;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/approval/approval-action/approval-action.component.ts